/** ngx-translate skips interpolation for falsy param values (including 0). */
export function toTranslateParams(
  params: Record<string, string | number | null | undefined>,
): Record<string, string> {
  return Object.fromEntries(
    Object.entries(params).map(([key, value]) => [key, value == null ? "" : String(value)]),
  );
}
